export default "__VITE_ASSET__0etlXtW8__"